window.upcartModifyCart = cart => {   
    setTimeout(_ => {
        //console.log(cart)
      if(!document.querySelector(".cart_gam > p")){
        return
      }
        const infoText = document.querySelector(".cart_gam > p")
        infoText.innerHTML = '<p>You are <span class="remaining"></span> away from <span class="reward"></span></p>'
        const remainingText = document.querySelector(".cart_gam .remaining")
        const rewardText = document.querySelector(".cart_gam .reward")
        const rewardsPrices = [160, 350, 450]
        const progressList = ["30%", "65%", "100%"]
        const total = cart.original_total_price / 100
        const hasGift = cart.items.some(item => item.id === 44837716459746)
        const addGift = total >= rewardsPrices[rewardsPrices.length - 1] && !hasGift ? true : false
        
        document.querySelectorAll(".cg_reward").forEach(async (reward, index, allRewards) => {
            reward.style.backgroundColor = total >= rewardsPrices[index] ? "var(--blue)" : "var(--gray)"
            if(total >= rewardsPrices[index]){
                document.querySelector(".cg_progress").style.setProperty('--progress', progressList[index]);
                if(rewardsPrices[index + 1]){
                    remainingText.textContent = `$${Math.trunc(Math.abs(total - rewardsPrices[index + 1]))}`
                    rewardText.textContent = allRewards[index + 1].getAttribute("data-title")
                }else{
                    if(addGift){
                        try {
                            const res = await fetch("/cart/add.js",{
                                method: "POST",
                                headers: {
                                    'Content-Type': 'application/json'
                                },
                                body: JSON.stringify({ 
                                    items: [{
                                        id: 44837716459746,
                                        quantity: 1
                                    }]
                                })
                            })
                            const json = await res.json();
                            //console.log(json)
                        } catch (error) {
                            console.log(error)
                        }
                    }
                    infoText.innerHTML = `Congrats! You've received a <span class="remaining"></span><span class="reward">${allRewards[ allRewards.length - 1].getAttribute("data-title")}</span>`
                } 
            }else if(total < rewardsPrices[0]){
                document.querySelector(".cg_progress").style.setProperty('--progress', "0%");
                remainingText.textContent = `$${Math.trunc(Math.abs(total - rewardsPrices[0]))}`
                rewardText.textContent = allRewards[0].getAttribute("data-title")
            }
            setTimeout(_ => {
                if(hasGift && !addGift && total <= rewardsPrices[rewardsPrices.length - 1]){
                    const gift = cart.items.find(item => item.id === 44837716459746)
                    const itemToRemove = window[`${gift.key}`].querySelector("[class*='styles_TrashButton__deleteButton']")
                    if(itemToRemove){
                        itemToRemove.click()
                    }
                }
            }, 100)
        })
    }, 100)
    

    return cart; 
};